import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import BetDetails from '@/views/BetDetails.vue'
import AuthPage from '@/views/AuthPage.vue'
import CreateUser from '@/views/CreateUser.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
  {
    path: '/bets/:id',
    name: 'BetDetails',
    props: true,
    component: BetDetails,
  },
  {
    path: '/auth',
    name: 'AuthPage',
    props: true,
    component: AuthPage,
  },
  {
    path: '/new',
    name: 'CreateUser',
    props: false,
    component: CreateUser,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
